import actions from '@/core/store/ata/controle-saldos-orgao/actions'

export default {
	actions,
}
